import { Box, Button, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getIntegrationsRequest } from 'redux/reducers/settings/reducer';

export type TPopupScreensaverProps = {
	popup: Window | null;
};
export const PopupScreensaver: FC<TPopupScreensaverProps> = ({ popup }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [popupOpened, setPopupOpened] = useState(true);
	useEffect(() => {
		if (!popup) {
			return;
		}

		const timer = setInterval(() => {
			if (!popup) {
				timer && clearInterval(timer);
				return;
			}
			if (!popup?.location) return;
			if (popup.closed) {
				if (popupOpened) {
					navigate({ pathname: location.pathname, search: 'closed=true' });
					dispatch(getIntegrationsRequest());
				}
				setPopupOpened(false);
				// setPopup(null);
				timer && clearInterval(timer);
				// dispatch(getIntegrationsRequest());
			}
		}, 500);
	}, [dispatch, location, navigate, popup, popupOpened]);

	if (!popupOpened || !popup) {
		return null;
	}
	return (
		<Box
			sx={{
				position: 'fixed',
				zIndex: 2147483647,
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				transform: 'translate3d(0, 0, 0)',
				backgroundColor: 'rgba(0, 0, 0, 0.8)',
				background:
					'radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%)',
				color: '#fff',
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: '40%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					fontSize: '1.2rem',
					fontWeight: 'bold',
				}}
			>
				<Typography
					sx={{
						fontSize: '1.2rem',
						fontWeight: 'bold',
					}}
				>
					Don’t see the secure HMRC browser?
					<br />
					We will help you go to the window to finish the pairing.
				</Typography>
				<Button
					type="button"
					onClick={() => {
						popup.focus();
					}}
					sx={{
						// position: 'absolute',
						// bottom: '20%',
						// left: '50%',
						// transform: 'translateX(-50%)',
						// backgroundColor: '#fff',
						color: '#fff',
						textTransform: 'none',
						textDecoration: 'underline',
						fontSize: '1rem',
					}}
					variant="text"
				>
					Click to Continue
				</Button>
				<Button
					type="button"
					onClick={() => {
						setPopupOpened(false);
						navigate({ pathname: location.pathname, search: 'closed=true' });
					}}
					sx={{
						// position: 'absolute',
						// bottom: '20%',
						// left: '50%',
						// transform: 'translateX(-50%)',
						// backgroundColor: '#fff',
						color: '#fff',
						textTransform: 'none',
						textDecoration: 'underline',
						fontSize: '1rem',
					}}
					variant="text"
				>
					Close
				</Button>
			</Box>
		</Box>
	);
};
